// extracted by mini-css-extract-plugin
module.exports = {"header":"PublicViewStoryPair_header__I_-7r","story":"PublicViewStoryPair_story__V9OFf"};